<template>
  <div>
    <!-- alerta -->
    <Alert
      :alert="alert"
      :type="alertType"
      :title="alertTitle"
      :message="alertMessage"
    />

    <template v-if="skeletonLoader">
      <v-skeleton-loader
        type="table-heading, table-thead, table-tbody@2, table-tfoot"
      >
      </v-skeleton-loader>
    </template>
    <template v-else>
      <!-- tabla -->
      <v-card>
        <v-card-title class="text-h5 font-weight-bold primary--text">
          <v-row>
            <v-col 
              cols="12"
              sm="8"
            >
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    fab
                    small
                    exact
                    color="primary"
                    class="mr-4"
                    v-bind="attrs" 
                    v-on="on" 
                    @click="regresar"
                  >
                    <v-icon>mdi-arrow-left</v-icon>
                  </v-btn>
                </template>
                <span>Regresar</span>
              </v-tooltip>
              Gestionar Participantes
            </v-col>

            <v-col 
              cols="12"
              sm="4"
            >
              <div class="d-flex align-center">
                <v-text-field
                  outlined
                  dense
                  hide-details
                  append-icon="mdi-magnify"
                  label="Buscar Participante"
                  class="mr-4"
                  v-model="searchTable"
                >
                </v-text-field>

                <v-btn
                  exact
                  color="primary"
                  @click="open"
                >
                  Registrar
                </v-btn> 
              </div>
            </v-col>

            <v-col 
              cols="5"
              offset-sm="1"
              sm="2"
            >
              <p class="text-subtitle-1 font-weight-bold primary--text">
                Cupos Asignados: {{ cupoCategoria.numero_participantes }}
              </p>
            </v-col>

            <v-col
              cols="5"
              sm="2"
            >
              <p 
                :class="['text-subtitle-1', 'font-weight-bold', {'error--text': cuposDisponibles == 0}]"
              >
                Disponibles: {{ cuposDisponibles }}
              </p>
            </v-col>
          </v-row>
        </v-card-title>

        <v-data-table
          fixed-header
          height="calc(100vh - 280px)"
          class="elevation-2"
          :loading="skeletonLoader"
          :headers="headersTable"
          :items="participantes"
          :search="searchTable"
          :footer-props="{ 'items-per-page-options': [50, 100, -1] }"
        >

          <template v-slot:[`item.acciones`]="{ item }">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  color="primary"
                  class="mr-2"
                  v-bind="attrs" 
                  v-on="on"
                  @click="detalles(item.id)"
                >
                  mdi-eye
                </v-icon>
              </template>
              <span>Detalles</span>
            </v-tooltip>

            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  color="primary"
                  class="mr-2"
                  v-bind="attrs" 
                  v-on="on"
                  @click="editar(item.id)"
                >
                  mdi-pencil
                </v-icon>
              </template>
              <span>Actualizar</span>
            </v-tooltip>

            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  color="error"
                  v-bind="attrs" 
                  v-on="on"
                  @click="alertaEliminar(item.id)"
                >
                  mdi-delete
                </v-icon>
              </template>
              <span>Eliminar</span>
            </v-tooltip>
          </template>

          <template v-slot:top>
            <v-dialog 
              persistent
              scrollable
              max-width="520px"
              v-model="dialogForm" 
            >
              <v-card :loading="loadingForm">
                <v-card-title class="justify-center">
                  <p class="text-h5 font-weight-bold primary--text">
                    {{ formTitle }}
                  </p>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row justify="center">
                      <v-col 
                        cols="12"
                        md="10"
                      >
                        <v-form 
                          ref="form" 
                          v-model="form"
                        >
                          <v-text-field
                            outlined
                            dense
                            disabled
                            type="text"
                            label="Competencia"
                            v-model="competenciaSeleccionada"
                          >
                          </v-text-field>

                          <v-text-field
                            outlined
                            dense
                            disabled
                            type="text"
                            label="Categoria"
                            v-model="categoriaSeleccionada"
                          >
                          </v-text-field>

                          <v-autocomplete 
                            outlined 
                            small-chips 
                            label="Programa de Formación*"
                            :items="programasFormacion"
                            item-value="id"
                            item-text="programa_formacion"
                            v-model="programaFormacion"
                            :rules="programaFormacionReglas"
                          >
                          </v-autocomplete >

                          <v-text-field
                            outlined
                            dense
                            type="number"
                            maxlength="10"
                            counter
                            label="Número de Ficha"
                            :rules="numeroFichaReglas"
                            v-model="numeroFicha"
                          >
                          </v-text-field>

                          <v-select
                            outlined
                            dense
                            label="Tipo de Identificación*"
                            :items="tiposIdentificacion"
                            item-value="id"
                            item-text="tipo_identificacion"
                            v-model="tipoIdentificacion"
                            :rules="tipoIdentificacionReglas"
                          >
                          </v-select>

                          <v-text-field
                            outlined
                            dense
                            type="number"
                            label="Número de Identificación*"
                            v-model="identificacion"
                            :rules="identificacionReglas"
                          >
                          </v-text-field>

                          <v-text-field
                            outlined
                            dense
                            type="text"
                            label="Nombres*"
                            maxlength="50"
                            counter
                            v-model.trim="nombres"
                            :rules="nombresReglas"
                          >
                          </v-text-field>

                          <v-text-field
                            outlined
                            dense
                            type="text"
                            label="Apellidos*"
                            maxlength="50"
                            counter
                            v-model.trim="apellidos"
                            :rules="apellidosReglas"
                          >
                          </v-text-field>

                          <v-text-field
                            outlined
                            dense
                            type="text"
                            label="Correo Electronico*"
                            maxlength="50"
                            counter
                            v-model.trim="correo"
                            :rules="correoReglas"
                          >
                          </v-text-field>

                          <v-text-field
                            outlined
                            dense
                            type="number"
                            label="Telefono Movil*"
                            maxlength="10"
                            counter
                            v-model="telefonoMovil"
                            :rules="telefonoMovilReglas"
                          >
                          </v-text-field>

                          <v-text-field
                            outlined
                            dense
                            type="text"
                            label="Direccion*"
                            maxlength="50"
                            counter
                            v-model.trim="direccion"
                            :rules="direccionReglas"
                          >
                          </v-text-field>

                          <v-dialog 
                            ref="fechaNacimiento" 
                            persistent
                            width="300px"
                            v-model="dialogFechaNacimiento" 
                            :return-value.sync="fechaNacimiento"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field 
                                outlined 
                                dense 
                                readonly
                                prepend-inner-icon="mdi-calendar" 
                                label="Fecha de Nacimiento*" 
                                v-model="fechaNacimiento" 
                                :rules="fechaNacimientoReglas" 
                                v-bind="attrs" 
                                v-on="on"
                              >
                              </v-text-field>
                            </template>

                            <v-date-picker 
                              scrollable 
                              color="primary"
                              v-model="fechaNacimiento"
                            >
                              <v-spacer></v-spacer>
                              <v-btn 
                                text 
                                color="error" 
                                @click="dialogFechaNacimiento = false"
                              >
                                Cancelar
                              </v-btn>
                              <v-btn 
                                text 
                                color="primary" 
                                @click="$refs.fechaNacimiento.save(fechaNacimiento)"
                              >
                                OK
                              </v-btn>
                            </v-date-picker>
                          </v-dialog>

                          <v-select
                            outlined
                            dense
                            label="Genero*"
                            :items="generos"
                            item-value="id"
                            item-text="genero"
                            v-model="genero"
                            :rules="generoReglas"
                          >
                          </v-select>

                          <v-select
                            outlined
                            dense
                            label="Estado Civil*"
                            :items="estadosCiviles"
                            item-value="id"
                            item-text="estado_civil"
                            v-model="estadoCivil"
                            :rules="estadoCivilReglas"
                          >
                          </v-select>

                          <v-select
                            outlined
                            dense
                            label="Estrato*"
                            :items="estratos"
                            item-value="id"
                            item-text="estrato"
                            v-model="estrato"
                            :rules="estratoReglas"
                          >
                          </v-select>

                          <v-select
                            outlined
                            dense
                            label="Zona*"
                            :items="zonas"
                            item-value="id"
                            item-text="zona"
                            v-model="zona"
                            :rules="zonaReglas"
                          >
                          </v-select>

                          <v-select
                            outlined
                            dense
                            label="Discapacidad*"
                            :items="discapacidades"
                            item-value="id"
                            item-text="discapacidad"
                            v-model="discapacidad"
                            :rules="discapacidadReglas"
                          >
                          </v-select>

                          <v-select
                            outlined
                            dense
                            label="Talla de Camiseta*"
                            :items="tallas"
                            v-model="talla"
                            :rules="tallaReglas"
                          >
                          </v-select>
                        </v-form>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn 
                    text 
                    color="error" 
                    @click="close"
                  >
                    Cancelar
                  </v-btn>
          
                  <template v-if="editedIndex === -1">
                    <v-btn 
                      text 
                      exact 
                      color="primary" 
                      @click="registrar"
                    >
                      Registrar
                    </v-btn>
                  </template>

                  <template v-else>
                    <v-btn 
                      text 
                      exact 
                      color="primary" 
                      @click="actualizar"
                    >
                      Actualizar
                    </v-btn>
                  </template>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </template>
        </v-data-table>
        
        <v-dialog 
          v-model="dialogDelete" 
          max-width="500px"
        >
          <v-card>
            <v-card-title class="justify-center text-h6">
              ¿Desea eliminar el participante?
            </v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn 
                text 
                color="error" 
                @click="closeDelete"
              >
                Cancelar
              </v-btn>
              <v-btn 
                text 
                color="primary" 
                @click="eliminar"
              >
                OK
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card>
    </template>
  </div>
</template>

<script>
import Alert from '../../../components/admin/Alert.vue'

export default {
  data: () => ({
    skeletonLoader: true,
    searchTable: null,

    alert: false,
    alertType: '',
    alertTitle: '',
    alertMessage: '',

    headersTable: [
      {
        text: "Identificación",
        value: "identificacion",
        align: "start",
        class: ["text-subtitle-1", "font-weight-black"],
      },

      {
        text: "Nombres",
        value: "nombres",
        align: "start",
        class: ["text-subtitle-1", "font-weight-black"],
      },

      {
        text: "Apellidos",
        value: "apellidos",
        align: "start",
        class: ["text-subtitle-1", "font-weight-black"],
      },

      {
        text: "Correo Electrónico",
        value: "correo",
        align: "start",
        sortable: false,
        filterable: false,
        class: ["text-subtitle-1", "font-weight-black"],
      },

      {
        text: "Categoria",
        value: "categoria",
        align: "start",
        class: ["text-subtitle-1", "font-weight-black"],
      },
  
      {
        text: "Acciones",
        value: "acciones",
        align: "center",
        sortable: false,
        filterable: false,
        class: ["text-subtitle-1", "font-weight-black"],
      }
    ],

    form: true,
    loadingForm: false,

    dialogForm: false,
    dialogDelete: false,

    competenciaSeleccionada: '',
    categoriaSeleccionada: '',

    programaFormacion: null,
    programaFormacionReglas: [
      v => !!v || "Seleccione un programa de formación"
    ],

    numeroFicha: '',
    numeroFichaReglas: [
      v => !!v || "Escriba un número de ficha",
      v => v > 0 || "No puede ser menor a 0",
      v => (v && v.length <= 10) || "Maximo 10 digitos",
    ],

    tipoIdentificacion: null,
    tipoIdentificacionReglas: [
      (v) => !!v || "Seleccione un tipo de Identififcacion",
    ],
    tiposIdentificacion: [
      { tipo_identificacion: "Tarjeta de Identidad", id: 1 },
      { tipo_identificacion: "Cedula de Ciudadania", id: 2 },
      { tipo_identificacion: "Documento Extranjero", id: 3 }
    ],

    identificacion: '',
    identificacionReglas: [
      (v) => !!v || "Escriba un número de identificación",
      (v) => (v && v.length <= 10) || "Maximo 10 digitos",
      (v) => (v && v.length >= 6) || "Minimo 6 digitos",
    ],

    nombres: '',
    nombresReglas: [(v) => !!v || "Escriba los nombres"],

    apellidos: '',
    apellidosReglas: [(v) => !!v || "Escriba los apellidos"],

    correo: '',
    correoReglas: [
      (v) => !!v || "Escriba un correo electrónico",
      (v) => /.+@.+\..+/.test(v) || "Correo electrónico no válido",
    ],

    telefonoMovil: '',
    telefonoMovilReglas: [
      (v) => !!v || "Escriba un número de telefono movil",
      (v) => (v && v.length <= 10) || "Maximo 10 digitos"
    ],

    direccion: '',
    direccionReglas: [(v) => !!v || "Escriba una dirección"],

    dialogFechaNacimiento: false,
    fechaNacimiento: null,
    fechaNacimientoReglas: [(v) => !!v || "Seleccione una fecha"],

    genero: null,
    generoReglas: [
      (v) => (!!v) || "Seleccione un genero",
    ],
    generos: [
      { genero: "Femenino", id: 1 },
      { genero: "Masculino", id: 2 },
    ],

    estadoCivil: null,
    estadoCivilReglas: [(v) => !!v || "Seleccione un estado civil"],
    estadosCiviles: [
      { estado_civil: "Viudo", id: 1 },
      { estado_civil: "Separado", id: 2 },
      { estado_civil: "Unión Libre", id: 3 },
      { estado_civil: "Casado", id: 4 },
      { estado_civil: "Soltero", id: 5 },
      { estado_civil: "Indiferente", id: 6 }
    ],

    estrato: null,
    estratoReglas: [(v) => !!v || "Seleccione un estrato"],
    estratos: [
      { estrato: 1, id: 1 },
      { estrato: 2, id: 2 },
      { estrato: 3, id: 3 },
      { estrato: 4, id: 4 },
      { estrato: 5, id: 5 },
      { estrato: 6, id: 6 },
    ],

    zona: null,
    zonaReglas: [(v) => !!v || "Seleccione una zona"],
    zonas: [
      { zona: "Urbana", id: 1 },
      { zona: "Rural", id: 2 },
    ],

    discapacidad: null,
    discapacidadReglas: [(v) => !!v || "Seleccione una discapacidad"],
    discapacidades: [
      { discapacidad: "Ninguna", id: 1 },
      { discapacidad: "Cognitiva", id: 2 },
      { discapacidad: "Fisica", id: 3 },
    ],

    talla: null,
    tallas: ["XS", "S", "M", "L", "XL", "XXL"],
    tallaReglas: [
      (v) => !!v || "Seleccione una talla"
    ],

    idPersona: null,
    idParticipante: null,
    editedIndex: -1,
  }),

  components: {
    Alert
  },

  mounted() {
    this.$store.dispatch("crearProgramasFormacion")
    this.$store.dispatch("gestionarParticipantes", this.$route.params.id_competencia);
    this.$store.dispatch("gestionarCupos", this.$route.params.id_competencia);

    setTimeout(() => {
      this.skeletonLoader = false;
    }, 1000);
  },

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Registrar Participante' : 'Actualizar Participante'
    },

    usuario() {
      return this.$store.getters.usuario;
    },

    participantes() {
      return this.$store.getters.obtenerParticipantes(this.$route.params.id_categoria, this.usuario.centro_formacion_id);
    },

    programasFormacion() {
      return this.$store.getters.obtenerProgramasFormacion
    },

    cupoCategoria() {
      return this.$store.getters.obtenerCupoAsignadoCategoria(this.usuario.centro_formacion_id, this.$route.params.id_categoria);
    },

    cuposDisponibles() {
      return this.cupoCategoria.numero_participantes-this.participantes.length
    }
  },

  watch: {
    dialogForm(val) {
      val || this.close()
    },

    dialogDelete(val) {
      val || this.closeDelete()
    }
  },

  methods: {
    open() {
      this.dialogForm = true
      this.competenciaSeleccionada = this.cupoCategoria.competencia
      this.categoriaSeleccionada = this.cupoCategoria.categoria
    },

    close() {
      this.$refs.form.reset();
      this.dialogForm = false
      this.editedIndex = -1
    },

    registrar() {
      if (this.$refs.form.validate()) {
        const nombresPersona = this.nombres.split(" ")
        const apellidosPersona = this.apellidos.split(" ")

        const participante = {
            competencia_id:         this.$route.params.id_competencia,
            categoria_id:           this.$route.params.id_categoria,
            centro_formacion_id:    this.usuario.centro_formacion_id,
            programa_formacion_id:  this.programaFormacion,
            numero_ficha:           this.numeroFicha,
            tipo_identificacion_id: this.tipoIdentificacion,
            identificacion:         this.identificacion,
            primer_nombre:          nombresPersona[0],
            segundo_nombre:         nombresPersona[1],
            primer_apellido:        apellidosPersona[0],
            segundo_apellido:       apellidosPersona[1],
            correo:                 this.correo,
            telefono_movil:         this.telefonoMovil,
            direccion:              this.direccion,
            fecha_nacimiento:       this.fechaNacimiento,
            genero_id:              this.genero,
            estado_civil_id:        this.estadoCivil,
            estrato:                this.estrato,
            zona_id:                this.zona,
            discapacidad_id:        this.discapacidad,
            talla_camiseta:         this.talla
        }

        this.loadingForm = true;

        this.$store.dispatch("registrarParticipante", participante)
        .then((response) => {
          if (response.status == "success") {
            this.loadingForm  = false;
            this.close();

            let message       = response.message.split(',')
            this.alertType    = "success--text";
            this.alertTitle   = message[0];
            this.alertMessage = message[1];
            this.alert        = true;

            this.skeletonLoader = true

            this.$store.dispatch("gestionarParticipantes", this.$route.params.id_competencia);
            setTimeout(() => {
              this.alert = false;
              this.skeletonLoader = false;
            }, 1000);
          } 
          else {
            this.loadingForm  = false
            this.alertType    = "error--text";
            this.alertTitle   = "Error";

            for (const error in response.message) {
              this.alertMessage = response.message[error][0]
            }

            this.alert = true;

            setTimeout(() => {
              this.alert = false
            }, 3000)
          }
        })
        .catch(() => {
        });
      }
    },

    detalles(id) {
      this.$router.push({
        name: "participante-detalle",
        params: { id_participante: id }
      });
    },

    editar(id) {
      this.editedIndex = 1;

      this.$store.dispatch("detallesParticipante", id);

      setTimeout(() => {
        const participante = this.$store.getters.obtenerParticipante

        this.idParticipante           = id;
        this.competenciaSeleccionada  = this.cupoCategoria.competencia;
        this.categoriaSeleccionada    = this.cupoCategoria.categoria;
        this.programaFormacion        = participante.programa_formacion_id;
        this.numeroFicha              = participante.numero_ficha;
        this.idPersona                = participante.persona_id;
        this.tipoIdentificacion       = participante.tipo_identificacion_id;
        this.identificacion           = participante.identificacion;
        this.nombres                  = participante.nombres;
        this.apellidos                = participante.apellidos;
        this.correo                   = participante.correo;
        this.telefonoMovil            = participante.telefono_movil;
        this.direccion                = participante.direccion;
        this.fechaNacimiento          = participante.fecha_nacimiento;
        this.genero                   = participante.genero_id;
        this.estadoCivil              = participante.estado_civil_id;
        this.estrato                  = participante.estrato;
        this.zona                     = participante.zona_id;
        this.discapacidad             = participante.discapacidad_id;
        this.talla                    = participante.talla_camiseta;
      }, 1000);

      this.dialogForm = true;
    },

    actualizar() {
      if (this.$refs.form.validate()) {
        const nombresPersona = this.nombres.split(" ")
        const apellidosPersona = this.apellidos.split(" ")

        const participante = {
          id:                     this.idParticipante,
          competencia_id:         this.$route.params.id_competencia,
          categoria_id:           this.$route.params.id_categoria,
          centro_formacion_id:    this.usuario.centro_formacion_id,
          programa_formacion_id:  this.programaFormacion,
          numero_ficha:           this.numeroFicha,
          id_persona:             this.idPersona,
          tipo_identificacion_id: this.tipoIdentificacion,
          identificacion:         this.identificacion,
          primer_nombre:          nombresPersona[0],
          segundo_nombre:         nombresPersona[1],
          primer_apellido:        apellidosPersona[0],
          segundo_apellido:       apellidosPersona[1],
          correo:                 this.correo,
          telefono_movil:         this.telefonoMovil,
          direccion:              this.direccion,
          fecha_nacimiento:       this.fechaNacimiento,
          genero_id:              this.genero,
          estado_civil_id:        this.estadoCivil,
          estrato:                this.estrato,
          zona_id:                this.zona,
          discapacidad_id:        this.discapacidad,
          talla_camiseta:         this.talla
        };

        this.loadingForm = true

        this.$store.dispatch("actualizarParticipante", participante)
        .then((response) => {
          if (response.status == "success") {
            this.loadingForm = false;
            this.close();
            
            let message       = response.message.split(',')
            this.alertType    = "success--text";
            this.alertTitle   = message[0];
            this.alertMessage = message[1];
            this.alert        = true;

            this.skeletonLoader = true;

            this.$store.dispatch("gestionarParticipantes", this.$route.params.id_competencia);
            setTimeout(() => {
              this.alert = false;
              this.skeletonLoader = false
            }, 1000)
          } 
          else {
            this.loadingForm  = false
            this.alertType    = "error--text";
            this.alertTitle   = "Error";

            for (const error in response.message) {
              this.alertMessage = response.message[error][0]
            }

            this.alert = true;

            setTimeout(() => {
              this.alert = false
            }, 3000)
          }
        })
        .catch(() => {});
      }
    },

    alertaEliminar(id) {
      this.idParticipante = id
      this.dialogDelete = true
    },

    eliminar() {
      this.dialogDelete = false
 
      this.$store.dispatch("eliminarParticipante", this.idParticipante)
      .then((response) => {
        if (response.status == "success") {
          let message       = response.message.split(',')
          this.alertType    = "success--text";
          this.alertTitle   = message[0];
          this.alertMessage = message[1];
          this.alert        = true;

          this.skeletonLoader = true;
          
          this.$store.dispatch("gestionarParticipantes", this.$route.params.id_competencia);
          setTimeout(() => {
            this.alert = false;
            this.skeletonLoader = false;
          }, 1000);
        } 
        else {
          this.loadingForm  = false
          this.alertType    = "error--text";
          this.alertTitle   = "Error";

          for (const error in response.message) {
            this.alertMessage = response.message[error][0]
          }

          this.alert = true;

          setTimeout(() => {
            this.alert = false
          }, 3000)
        }
      })
      .catch(() => {});
    },

    closeDelete () {
      this.dialogDelete = false;
      this.editedIndex = -1;
    },

    regresar() {
      this.$router.back()
    }
  },
};
</script>